import IModel from "~/interfaces/modelInterfaces";
import ElementHandler from "~/services/elementHandler";
import Vue from "vue";
import PropertySection from "~/models/objectModels/propertySection";
import {ArrayHelper} from "~/helpers/arrayHelper";
import ObjectModel from "~/models/objectModel";

export default class PropertySectionElementHandler<T extends IModel = any> extends ElementHandler {
  updateElementPositions(parent, movedElement, position: number) {
    let siblings = parent.objectModelPropertiesArray.filter((p) => {
      return !p.property_section_client_id
    })
    siblings = siblings.concat(parent.propertySectionsArray)

    ArrayHelper.updatePositionsByProp(siblings, movedElement, position, 'sort_order');
  }

  lastSortOrder(): number {
    return this.model.nextSortOrderFor('property_sections') - 1
  }
}
